export const SET_MY_PASSES = 'SET_MY_PASSES'

export const setMyPasses = passes => dispatch => {
  dispatch({
    type: SET_MY_PASSES,
    payload: passes,
  })
}
